import { AuthService } from './../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  resetForm!: FormGroup;
  password: any;
  confirmPassword: any;
  disableButton = false;
  isActive = false;
  userid: any;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.userid = this.route.snapshot.params.userId;
  }

  ngOnInit() {
    if (!this.authService.userResetInfo) this.router.navigate(['/']);
    this.resetForm = this.formBuilder.group({
      new_password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
          ),
        ],
      ],
      confirm_new_password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
          ),
        ],
      ],
    });
  }

  reset_password() {
    this.disableButton = true;
    const data = this.authService.userResetInfo;
    Object.assign(data, { password: this.password });
    this.authService.resetPassword(data, this.userid).subscribe(
      (data: any) => {
        this.disableButton = false;
        this.snackBar.open('Password updated successfully', '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
         localStorage.clear();
        this.router.navigate(['/login']);
      },
      (error) => {
        this.disableButton = false;
        if (!navigator.onLine) {
          error.error.message =
            'OOPS! NO INTERNET. Please check your network connection.';
        }
        this.snackBar.open('Something went wrong', '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
      }
    );
  }

  cancel() {
    this.router.navigate(['/login']);
  }
}
